(function () {
    'use strict';

    angular.module("imApp").factory("projectActivityTypeService", ['$ihttp', function ($ihttp) {
        let service = {
            getProjectActivityType: function (parms) {
                return $ihttp.post({
                    method: 2185,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2186,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
